module.exports = __webpack_public_path__ + "static/media/Whole Life Decision Tree.ebf0c897.pdf";